import { Row, Spacer } from "@amzn/stencil-react-components/layout";
import { H3 } from "@amzn/stencil-react-components/text";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { FC } from "react";

import { RelatedUseCase, RelatedUseCaseCard } from "./RelatedUseCaseCard";

export interface RelatedUseCasesProps {
  useCases: RelatedUseCase[];
}

export const RelatedUseCases: FC<RelatedUseCasesProps> = ({ useCases }) => {
  if (!useCases.length) return null;

  return (
    <>
      <Spacer height="dimensions.spacing.200" />
      <H3>{getString("useCases.detail.relatedUseCases")}</H3>
      <Row gridGap="dimensions.spacing.300" alignItems="stretch">
        {useCases.map((uc, i) => (
          <RelatedUseCaseCard key={i} useCase={uc} />
        ))}
      </Row>
    </>
  );
};
